import { Component, Entity2D } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';
import { OctopusBlockProps } from './OctopusBlock';
import { OctopusBlockView } from './OctopusBlockView';

export type OctopusBlockComponentOptions = {
  props: OctopusBlockProps;
  option?: number;
};

export class OctopusBlockComponent implements Component {
  public static readonly NAME = 'blockOctopus';

  public entity!: Entity2D;
  public view!: OctopusBlockView;
  private props!: OctopusBlockProps;
  private hitCount = 0;

  public init(args: OctopusBlockComponentOptions): void {
    this.props = args.props;

    // Create the view
    this.view = new OctopusBlockView(args.props);

    // Set the initial hit count
    this.count = args.option ?? 0;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    return this.hitCount;
  }

  public get count(): number {
    return this.hitCount;
  }

  public set count(value: number) {
    if (value < 0) value = 0;
    this.hitCount = value;
  }
}
